import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'openDemoProjectEditor',
  'translateYourVideoClick',
  'translateYourVideoEditorDemoClick',
  'upgradeApplyChangesEditorDemoClick',
  'onboardingFinishedEditorDemo',
  'upgradePlanAccountPageDemo',
] as const;

export const demoProjectsTrial = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
